import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * EmptyState — never leave a page blank.
 * Explains why it's empty and shows a primary CTA.
 * data-testid: `empty-state-{key}` if key provided
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  onSecondary,
  testId,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      className="relative overflow-hidden border border-border rounded-xl bg-card p-10 md:p-14 text-center"
      data-testid={testId || "empty-state"}
    >
      <div className="absolute inset-0 pattern-dots opacity-40 pointer-events-none" />
      <div className="relative">
        {Icon && (
          <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-5">
            <Icon size={26} strokeWidth={1.5} />
          </div>
        )}
        <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight text-foreground mb-2">
          {title}
        </h3>
        {description && (
          <p className="text-sm text-muted-foreground max-w-md mx-auto mb-6 leading-relaxed">
            {description}
          </p>
        )}
        <div className="flex items-center gap-3 justify-center flex-wrap">
          {actionLabel && (
            <Button onClick={onAction} data-testid={`${testId || "empty-state"}-action`} className="gap-2">
              {actionLabel} <ArrowRight size={14} />
            </Button>
          )}
          {secondaryLabel && (
            <Button variant="ghost" onClick={onSecondary} data-testid={`${testId || "empty-state"}-secondary`}>
              {secondaryLabel}
            </Button>
          )}
        </div>
      </div>
    </motion.div>
  );
}
